module.exports = __webpack_public_path__ + "static/media/glanum_therme_tn.a612cd2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_therme_tn.jpg
// module id = 724
// module chunks = 0